import { ContractManagementApiService } from './../../../app/@shared/services/contractmanagementapi.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as StatsActions from './stats.actions';
import { catchError, concatMap, filter, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { contractmanagement_api } from '@gridscale/gs-services/contractmanagement_api';
@Injectable()
export class StatsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly contractApi: ContractManagementApiService
  ) {}

  loadDashboardData = createEffect(() =>
    this.actions$.pipe(
      ofType(StatsActions.loadDashboard),
      concatMap((action) =>
        this.contractApi
          .get<Partial<contractmanagement_api.PartnerUsagesByMonthForGivenYearResponse>>(
            `/management/v2/usage/partner/##CURRENT_PARTNER_UUID##/starting/${new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              3
            )
              .toISOString()
              .slice(0, 7)}-01/months-in-past/12`
          )
          .pipe(
            filter((result) => result?.data !== undefined),
            map((result) =>
              StatsActions.loadDashboardSuccess({
                data: result.data!.map((data) => data.attributes),
              })
            ),
            catchError((error) =>
              of(
                StatsActions.loadDashboardFailure({ error }),
                globalFailure({ error })
              )
            )
          )
      )
    )
  );

  loadContractData = createEffect(() =>
    this.actions$.pipe(
      ofType(StatsActions.loadAccountUsage),
      concatMap((action) =>
        this.contractApi
          .get<Partial<contractmanagement_api.ContractUsagesByWeekForLastGivenMonthsResponse>>(
            `/management/v2/usage/contract/${
              action.accountId
            }/starting/${new Date(
              new Date().getFullYear(),
              new Date().getMonth() + 1,
              3
            )
              .toISOString()
              .slice(0, 7)}-01/months-in-past/12`
          )
          .pipe(
            filter((result) => result?.data !== undefined),
            map((result) =>
              StatsActions.loadContractUsageSuccess({
                accountId: action.accountId,
                data: result.data!.map((data) => data.attributes),
              })
            ),
            catchError((error) =>
              of(
                StatsActions.loadContractUsageFailure({
                  accountId: action.accountId,
                  error,
                }),
                globalFailure({ error })
              )
            )
          )
      )
    )
  );

  loadTopAccounts = createEffect(() =>
    this.actions$.pipe(
      ofType(StatsActions.loadTopAccounts),
      concatMap((action) =>
        this.contractApi
          .get<Partial<contractmanagement_api.PartnerStatsDetailResponse>>(
            '/management/v2/partner/stats/highest-usage-contracts'
          )
          .pipe(
            filter((result) => result?.data !== undefined),
            map((result) =>
              StatsActions.loadTopAccountsSuccess({
                data: result.data!.map((data) => data.attributes),
              })
            ),
            catchError((error) =>
              of(
                StatsActions.loadTopAccountsFailure({ error }),
                globalFailure({ error })
              )
            )
          )
      )
    )
  );

  loadFlopAccounts = createEffect(() =>
    this.actions$.pipe(
      ofType(StatsActions.loadFlopAccounts),
      concatMap((action) =>
        this.contractApi
          .get<Partial<contractmanagement_api.PartnerStatsDetailResponse>>(
            '/management/v2/partner/stats/lowest-usage-contracts'
          )
          .pipe(
            filter((result) => result?.data !== undefined),
            map((result) =>
              StatsActions.loadFlopAccountsSuccess({
                data: result.data!.map((data) => data.attributes),
              })
            ),
            catchError((error) =>
              of(
                StatsActions.loadFlopAccountsFailure({ error }),
                globalFailure({ error })
              )
            )
          )
      )
    )
  );

  loadContractResources = createEffect(() =>
    this.actions$.pipe(
      ofType(StatsActions.loadAccountResources),
      concatMap((action) =>
        this.contractApi
          .get<Partial<contractmanagement_api.ContractUsagesByProductNumber>>(
            `/management/v2/usage/contract/${action.accountId}/current`
          )
          .pipe(
            map((result) =>
              StatsActions.loadContractResourcesSuccess({
                accountId: action.accountId,
                data: result,
              })
            ),
            catchError((error) =>
              of(
                StatsActions.loadContractResourcesFailure({
                  accountId: action.accountId,
                  error,
                }),
                globalFailure({ error, whitelist: [500 /* sad but true */] })
              )
            )
          )
      )
    )
  );
}
